<template>
  <div
    class="graphic-one-updown"
    :class="{ 'graphic-item-padding': isPadding }"
    :style="itemStyle"
  >
    <div class="left-pic" v-if="specialData.includeItemsImageOrVideo">
      <img
        :src="item.entryImg"
        v-if="item.entryImg"
        :alt="item.titleName"
        class="picture"
        :style="imgStyle"
      />
      <img
        :src="defaultImg"
        v-else
        :alt="item.titleName"
        class="picture default-picture"
        :style="imgStyle"
      />
      <img class="play-btn" v-if="item.fileType == 2 || item.selectType == 2" :src="playBtn" alt="" />
    </div>
    <div
      class="right-cont"
      :class="{
        'is-pad':
          specialStyle.oneGroupBorder || specialStyle.oneGroupBorderShadow,
        'is-clamp':
          specialStyle.oneGroupBorder ||
          specialStyle.oneGroupBorderShadow ||
          (!specialData.includeItemsImageOrVideo &&
            (specialStyle.oneGroupBorder || specialStyle.oneGroupBorderShadow)),
             'no-border':specialStyle.oneGroupBorder,
             'no-no-border':!specialStyle.oneGroupBorder,
            'no-left':specialStyle.oneGroupBorder&&specialStyle.oneGroupImageLeft=='0',

      }"
    >
      <div class="mark-list">
        <span
          class="mark" :class="specialStyle.listRemarkType == 1 ? 'circle': ''"
          :style="{'background':specialStyle.listRemarkColor}"
          v-if="specialData.isShowListRemark == 2 && !specialData.includeItemsImageOrVideo">
        </span>
        <h2
          class="graphic-title"
          :style="titleStyle"
          v-if="specialData.includeItemsTitle"
        >
          {{ item.titleName }}
        </h2>
      </div>
      <p
        class="summary"
        :style="summaryStyle"
        v-if="specialData.includeItemsDes"
      >
        {{ item.titleDes }}
      </p>
      <div class="create-time" v-if="specialData.showPublishFlag|| specialData.showReadFlag">
        <span v-if="specialData.showContentType == 2 && specialData.showPublishFlag">
                  {{ item.publishTime.substring(0,10) }}
        </span>
        <div

          v-if="specialData.showContentType == 2 && specialData.showReadFlag"
        >
          <img
            class="seeNum"
            src="https://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/04/1619767042239.png"
            alt=""
          />{{ item.readNum }}
        </div>
        <!-- ddd -->
      </div>
    </div>
  </div>
</template>
<script>
import playBtn from "../../asset/images/play-btn.png";
export default {
  data() {
    const {
      tempData: { specialData, specialStyle },
    } = this.data;
    return {
      playBtn,
      specialData,
      specialStyle,
    };
  },
  props: {
    data: {
      type: Object,
    },
    item: {
      type: Object,
    },
    defaultImg: {
      type: String,
    },
  },
  computed: {
    isPadding() {
      const { oneGroupBorder, oneGroupBorderShadow, oneGroupImageLeft } =
        this.specialStyle;
      const { includeItemsImageOrVideo } = this.specialData;
      if (
        (oneGroupBorder && !(oneGroupImageLeft == "1")) ||
        (oneGroupBorderShadow && !(oneGroupImageLeft == "1")) ||
        (!includeItemsImageOrVideo && (oneGroupBorder || oneGroupBorderShadow))
      ) {
        return true;
      }
      return false;
    },
    imgStyle() {
      const {
        imgRadius = false,
        imgShadow = false,
        imgBorder = false,
        // imgBorderColor='',
        imgBackgroundColor = "",
      } = this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor ? imgBackgroundColor : "",
        borderRadius: imgRadius ? "4px" : "0",
        boxShadow: imgShadow ? "0px 0px 8px 0px rgba(0, 0, 0, 0.1)" : "",
        border: imgBorder ? `1px solid #D6DEEA` : "none",
      };
    },
    itemStyle() {
      const {
        oneGroupBorder,
        oneGroupBGColor,
        oneGroupBorderRadius = false,
        oneGroupBorderShadow,
      } = this.specialStyle;
      return {
        border: oneGroupBorder ? "1px solid #D6DEEA" : "none",
        backgroundColor: oneGroupBGColor ? oneGroupBGColor : "none",
        boxShadow: oneGroupBorderShadow
          ? "0px 0px 8px 0px rgba(0, 0, 0, 0.1)"
          : "none",
        borderRadius: oneGroupBorderRadius ? "4px" : "0",
        // marginBottom:topBottomInterval+'px'

      };
    },
    titleStyle() {
      const {
        titleSize,
        titleColor = "#333",
        titleBold = false,
        titleAlign,
        titleLineHeight
      } = this.specialStyle;
      return {
        fontSize: `${titleSize}px`,
        color: titleColor,
        fontWeight: `${titleBold ? "bold" : ""}`,
        textAlign: titleAlign ? titleAlign : "center",
        lineHeight: titleLineHeight ? titleLineHeight: '1.4'
      };
    },
    summaryStyle() {
      const {
        descSize,
        descColor,
        descBold = false,
        descAlign,
        descLineHeight
      } = this.specialStyle;
      return {
        fontSize: `${descSize}px`,
        color: `${descColor ? descColor : "#666"}`,
        fontWeight: `${descBold ? "bold" : ""}`,
        textAlign: descAlign ? descAlign : "center",
        lineHeight: descLineHeight ? descLineHeight : '1.4'
      };
    },
  },
  methods: {},
  created() {
    if(this.item.publishTime) {
      this.item.publishItem = this.item.publishTime.substring(0, 10)
    }
    },
};
</script>
<style lang="less" scoped>
.graphic-one-updown {
  margin-bottom: 24px;
  width: 702px;
  box-sizing: border-box;
  .mark-list {
      display: flex;
      align-items: center;
      .mark {
        width: 12px;
        height: 12px;
        margin-right: 24px;
      }
      .mark.circle {
        border-radius: 50%;
      }
    }
  &.graphic-item-padding {
    padding: 24px;
    .right-cont.is-clamp {
      padding-right: 0;
    }
  }
  .left-pic {
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    .picture {
      width: 240px;
      height: 180px;
    }
    .play-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
    }
  }
  .right-cont {
    &.is-pad {
      padding: 0px 12px;
    }
    &.no-border{
      padding: 10px 12px;
    }

    &.no-no-border{
      padding: 0px 12px;
    }
    &.no-left{
      padding: 0px 12px;
    }



    &.is-clamp {
      .summary {
        -webkit-line-clamp: 1;
      }
      .create-time {
        margin-left: 0px;}
    }
    flex: 1;
    .graphic-title {
      // margin-top:10px;
      // height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      max-width: 400px;
      // line-height: 1.4;
    }
    .summary {
      margin-top: 12px;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      // line-height: 1.4;
    }
    .create-time {
      display: flex;
      margin-top: 12px;
      height: 36px;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
      .seeNum {
          width: 24px;
          margin: 0 10px 0 24px;
        }
    }
  }
}
</style>
